import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { ICategory, ICategoryCreatePayload, ICategoryUpdatePayload } from "../../../types/api/category";
import { AxiosResponse } from "axios";

export async function categoryList(
  qData: QData & { parentId?: string; search?: string }
): Promise<AxiosResponse<TResponseWithQData<ICategory[]>>> {
  return axios.get(API_ENDPOINTS.CATEGORY_LIST, { params: qData });
}

export async function categoryDetail(
  id: string
): Promise<AxiosResponse<TResponse<ICategory>>> {
  return axios.get(`${API_ENDPOINTS.CATEGORY_DETAIL}/${id}`);
}

export async function createCategory(
  data: ICategoryCreatePayload
): Promise<AxiosResponse<TResponse<ICategory>>> {
  return axios.post<TResponse<ICategory>>(API_ENDPOINTS.CATEGORY_CREATE, data);
}

export async function updateCategory(
  data: ICategoryUpdatePayload
): Promise<AxiosResponse<TResponse<ICategory>>> {
  const { _id, ...rest } = data;
  return axios.put<TResponse<ICategory>>(`${API_ENDPOINTS.CATEGORY_UPDATE}/${_id}`, rest);
}

export async function deleteCategory(
  id: string
): Promise<AxiosResponse<TResponse<null>>> {
  return axios.delete<TResponse<null>>(`${API_ENDPOINTS.CATEGORY_DELETE}/${id}`);
}
